import React from 'react';
import { SITE_NAME, SITE_URL, LOGO_URL, PHONE_DISPLAY, CONTACT_EMAIL, getCanonical } from '../../lib/seoConfig';

export const JsonLd = ({ data }) => (
  <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />
);

export const organizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: SITE_NAME,
  url: SITE_URL,
  logo: LOGO_URL,
  description:
    'Leading manufacturer of mineral water bottling plants, water filling machines, RO plants and PET bottle blowing machines in India. Complete turnkey plant solutions from 24 BPM to 200 BPM.',
  telephone: PHONE_DISPLAY,
  email: CONTACT_EMAIL,
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'IN',
    addressRegion: 'Rajasthan',
    addressLocality: 'Jaipur'
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: PHONE_DISPLAY,
    contactType: 'sales',
    availableLanguage: ['English', 'Hindi']
  }
});

const parsePriceRange = (range) => {
  if (!range) return null;
  const mult = /crore/i.test(range) ? 10000000 : /lakh/i.test(range) ? 100000 : 1;
  const nums = (range.match(/[\d.]+/g) || []).map(Number);
  if (!nums.length) return null;
  return { low: nums[0] * mult, high: (nums[1] || nums[0]) * mult };
};

export const productSchema = (product, path) => {
  const price = parsePriceRange(product.price?.range);
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: product.title,
    image: product.heroImage,
    description: product.metaDescription,
    sku: product.id,
    brand: { '@type': 'Brand', name: SITE_NAME },
    manufacturer: { '@type': 'Organization', name: SITE_NAME, url: SITE_URL }
  };
  if (price) {
    schema.offers = {
      '@type': 'AggregateOffer',
      priceCurrency: 'INR',
      lowPrice: price.low,
      highPrice: price.high,
      availability: 'https://schema.org/InStock',
      url: getCanonical(path)
    };
  }
  return schema;
};

export const faqSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q || f.question,
    acceptedAnswer: { '@type': 'Answer', text: f.a || f.answer }
  }))
});

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, idx) => ({
    '@type': 'ListItem',
    position: idx + 1,
    name: item.label,
    ...(item.to ? { item: getCanonical(item.to) } : {})
  }))
});

export const articleSchema = (meta, path) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: meta.title,
  description: meta.metaDescription,
  image: meta.image,
  datePublished: meta.publishDate,
  dateModified: meta.publishDate,
  author: { '@type': 'Organization', name: SITE_NAME, url: SITE_URL },
  publisher: {
    '@type': 'Organization',
    name: SITE_NAME,
    logo: { '@type': 'ImageObject', url: LOGO_URL }
  },
  mainEntityOfPage: { '@type': 'WebPage', '@id': getCanonical(path) }
});
